import React from 'react';
import { Search, Moon, Sun, Menu, LogOut, X } from 'lucide-react';
import { THEME } from '../theme';

function getInitials(name = '') {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

// --- Header Component ---
const Header = ({ darkMode, setDarkMode, user, showProfileCard, setShowProfileCard, handleLogout, setSidebarOpen, title }) => {
  
  return (
    <header className={`sticky top-0 z-30 backdrop-blur-xl border-b transition-all duration-300 ${darkMode ? 'bg-primary/80 border-slate-800' : 'bg-white/80 border-slate-200'}`}>
      <div className="w-full px-6 py-4 flex justify-between items-center">
        
        {/* Left: Mobile Menu & Title */}
        <div className="flex items-center gap-4">
          <button 
            onClick={() => setSidebarOpen(true)}
            className={`md:hidden p-2 rounded-lg ${darkMode ? 'hover:bg-slate-800 text-white' : 'hover:bg-slate-100 text-slate-900'}`}
          >
            <Menu size={20} />
          </button>
          <h1 className={`text-xl font-light tracking-tight flex items-center gap-1 capitalize ${darkMode ? 'text-white' : 'text-slate-900'}`}>
             {title}
          </h1>
        </div>
        
        {/* Center: Search Bar Removed (Non-functional) */}
        
        {/* Right: Theme Toggle & Profile */}
        <div className="flex items-center gap-3 animate-entry delay-200">
          <button onClick={() => setDarkMode(!darkMode)} className={`p-2 rounded-lg transition-all active:scale-95 hover:scale-105 ${darkMode ? 'bg-slate-800 hover:bg-slate-700 text-secondary' : 'bg-slate-100 hover:bg-slate-200 text-secondary'}`}>
            {darkMode ? <Sun size={18} fill="currentColor" /> : <Moon size={18} fill="currentColor" />}
          </button>
          
          <div className="relative">
            {/* Profile Avatar Button */}
            <button 
              onClick={(e) => { e.stopPropagation(); setShowProfileCard(!showProfileCard); }} 
              className="w-10 h-10 rounded-full p-[2px] transition-all hover:scale-105 active:scale-95 bg-secondary" 
            >
              <div className={`w-full h-full rounded-full flex items-center justify-center font-medium text-sm ${darkMode ? 'bg-primary text-white' : 'bg-white text-slate-900'}`}>
                {user ? getInitials(user.username || user.name) : <div className="w-2 h-2 rounded-full bg-current animate-ping" />}
              </div>
            </button>
            
            {/* Profile Dropdown Card */}
            {showProfileCard && user && (
              <div className="absolute top-14 right-0 z-50 w-72 p-4 rounded-xl shadow-none border animate-in fade-in zoom-in-95 bg-primary border-slate-800 text-white">
                <div className="flex justify-between mb-4">
                  <span className="text-[10px] font-medium uppercase tracking-widest opacity-50">Account</span>
                  <X size={14} className="cursor-pointer hover:opacity-70" onClick={() => setShowProfileCard(false)}/>
                </div>
                
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-medium text-lg bg-secondary">
                    {getInitials(user.username || user.name)}
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium truncate text-base">{user.username || user.name}</div>
                    <div className="text-xs opacity-50 truncate">{user.email}</div>
                  </div>
                </div>
                
                <button 
                  onClick={handleLogout} 
                  className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-red-500/10 text-red-500 hover:bg-red-500/20 transition-colors"
                >
                  <LogOut size={16} /> Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;